export const bootcamps = [
  {
    year: 2025,
    institution: "Maon GmbH",
    program: "Junior Software Developer",
    duration: "5 months",
  },
  {
    year: 2024,
    institution: "Erasmus+",
    program: "IoT for humanity",
    duration: "5 weeks",
  },
  {
    year: 2024,
    institution: "Erasmus+",
    program: "Champions of Carbon Neutrality",
    duration: "10 days",
  },
  {
    year: 2024,
    institution: "Science Park",
    program: "Startup Prog. SustainTech",
    duration: "2 months",
  },
  {
    year: 2023,
    institution: "Accenture Internship",
    program: "O365 & Power Platform MW Dev",
    duration: "840 working hours",
  },
  {
    year: 2022,
    institution: "Accenture Bootcamp",
    program: "Microsoft Tech and .NET",
    duration: "176 working hours",
  },
  {
    year: 2021,
    institution: "Datorium",
    program: "Python Advanced",
    duration: "80 working hours",
  },
  {
    year: 2021,
    institution: "Datorium",
    program: "Django",
    duration: "40 working hours",
  },
  {
    year: 2020,
    institution: "Datorium",
    program: "Python Boost",
    duration: "40 working hours",
  },
  {
    year: 2020,
    institution: "Datorium",
    program: "Python",
    duration: "80 working hours",
  },
  {
    year: 2019,
    institution: "Datorium",
    program: "VB.NET C#",
    duration: "80 working hours",
  },
  {
    year: 2020,
    institution: "All Oportunities",
    program: "Digital Skills",
  },
];
